<template>
  <div class="stepper">
    <naj-button
      v-for="step in steps"
      :key="step.title.split(' ').join('')"
      text
      class="step-item"
      :class="{active: selectedStep === step.id, done: selectedStep > step.id}"
      @click.native="updateCurrentStep(step.id)"
    >
      <div class="step-icon">
        <span v-if="selectedStep <= step.id">{{ step.order }}</span>
        <v-icon
          v-if="selectedStep > step.id"
          color="white"
        >
          mdi-check
        </v-icon>
      </div>
      <div class="step-name">
        {{ step.title }}
      </div>
    </naj-button>
  </div>
</template>

<script>

export default {
  name: 'RequestStepper',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    selectedStep() {
      return this.currentStep * 1;
    },
  },
  methods: {
    updateCurrentStep(stepId) {
      if (this.selectedStep > stepId) {
        this.$emit('onUpdateCurrentStep', stepId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    .stepper {
        display: flex;

        .step-item {
            margin-left: 15px;
            display: flex;

            .step-name {
                color: #dbdbdb;
                font-weight: 700;
                font-size: 14px;
            }

            .step-icon {
                width: 24px;
                height: 24px;
                border-radius: 100%;
                background-color: #dbdbdb;
                margin-left: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-weight: 700;
            }

            &.active {
                .step-name {
                    color: var(--app-primary-color);
                }

                .step-icon {
                    background-color: var(--app-primary-color);
                }
            }

            &.done {
                .step-name {
                    color: var(--app-dark-primary-color);
                }

                .step-icon {
                    background-color: var(--app-secondary-color);
                }
            }
        }
    }
</style>
